import PhonePreview from './PhonePreview';
import './PhonePreview.css';

export default PhonePreview;



// WEBPACK FOOTER //
// ./src/shared/components/PhonePreview/index.js